import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const WHATSAPP_NUMBER = process.env.REACT_APP_WHATSAPP_NUMBER || '+27000000000';
const IS_PLACEHOLDER = !process.env.REACT_APP_WHATSAPP_NUMBER || WHATSAPP_NUMBER === '+27000000000';

export function WhatsAppFAB() {
  const [showToast, setShowToast] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    if (IS_PLACEHOLDER) {
      e.preventDefault();
      setShowToast(true);
      setTimeout(() => setShowToast(false), 4000);
    }
  };

  return (
    <>
      <motion.a
        href={IS_PLACEHOLDER ? '#' : `https://wa.me/${WHATSAPP_NUMBER}?text=Hi%2C%20I%27d%20like%20to%20book%20an%20appointment`}
        target={IS_PLACEHOLDER ? undefined : '_blank'}
        rel="noopener noreferrer"
        onClick={handleClick}
        className="fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3 rounded-full font-semibold shadow-lg"
        style={{ backgroundColor: '#25D366', color: 'var(--color-navy)' }}
        aria-label="Chat with us on WhatsApp"
        whileHover={{ scale: 1.07 }}
        whileTap={{ scale: 0.96 }}
        transition={{ type: 'spring', stiffness: 400, damping: 20 }}
      >
        <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
          <path d="M20.52 3.48A11.94 11.94 0 0 0 12 0C5.37 0 0 5.37 0 12c0 2.12.55 4.1 1.52 5.83L0 24l6.33-1.49A11.94 11.94 0 0 0 12 24c6.63 0 12-5.37 12-12 0-3.21-1.25-6.22-3.48-8.52zm-8.52 18.4a9.92 9.92 0 0 1-5.06-1.38l-.36-.22-3.76.89.9-3.64-.24-.38A9.93 9.93 0 0 1 2.08 12c0-5.47 4.45-9.92 9.92-9.92a9.86 9.86 0 0 1 7.02 2.91A9.86 9.86 0 0 1 21.92 12c0 5.47-4.45 9.88-9.92 9.88zm5.44-7.43c-.3-.15-1.77-.87-2.04-.97-.27-.1-.47-.15-.67.15-.2.3-.77.97-.94 1.17-.17.2-.35.22-.65.07a8.16 8.16 0 0 1-2.4-1.48 9.03 9.03 0 0 1-1.66-2.07c-.17-.3-.02-.46.13-.61.13-.13.3-.35.45-.52.15-.17.2-.3.3-.5.1-.2.05-.37-.02-.52-.07-.15-.67-1.6-.91-2.2-.24-.57-.49-.5-.67-.5l-.57-.01c-.2 0-.52.07-.8.37-.27.3-1.03 1.01-1.03 2.46s1.06 2.85 1.2 3.05c.15.2 2.08 3.18 5.04 4.46.7.3 1.25.48 1.68.62.7.22 1.34.19 1.85.11.56-.08 1.77-.72 2.02-1.42.25-.7.25-1.3.17-1.42-.07-.12-.27-.2-.57-.35z" />
        </svg>
        <span className="text-sm font-body" style={{ fontFamily: 'var(--font-body)' }}>
          Chat with us
        </span>
      </motion.a>

      {/* Toast for placeholder number */}
      <AnimatePresence>
        {showToast && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            className="fixed bottom-24 right-6 z-50 max-w-xs px-4 py-3 rounded-lg shadow-lg text-sm font-body"
            style={{
              backgroundColor: 'var(--color-navy)',
              color: '#fff',
              fontFamily: 'var(--font-body)',
            }}
          >
            WhatsApp booking coming soon — please call us or use the{' '}
            <a href="/book" className="underline font-semibold" style={{ color: 'var(--color-gold)' }}>
              booking form
            </a>.
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
